// TODO: 1. beforeDestroy life cycle didn't trigger 2. Now can only support 1 dialog instance

import Vue, { VueConstructor, VNode } from 'vue';
import Dialog from './Dialog.vue';

let component: any = null;

export interface DialogProps {
  title?: string;
  content: string | VNode;
  buttons?: any[];
  loading?: boolean;
  className?: string;
  component?: VNode;
  componentBackground?: 'white' | 'transparent' | 'grey' |'blurry';
}

const DialogComponent = Vue.extend(Dialog);
const isVnode = function (node: any) {
  const hasOwn = (obj: Object, key: string) => window.hasOwnProperty.call(obj, key);
  if (!node || typeof node !== 'object') return false;
  return hasOwn(node, 'tag') && hasOwn(node, 'componentOptions');
};

const handleCLose = () => {
  if (!component) return;
  const elm = component.$el;
  if (elm && elm.parentNode) {
    elm.parentNode.removeChild(elm);
  }
};

const dialog = (config: DialogProps) => {
  handleCLose();
  component = new DialogComponent({
    propsData: { ...config, hasSlot: isVnode(config.content) },
  });
  component.$mount();

  if (isVnode(config.content)) {
    component.$slots.default = [config.content as VNode];
  }

  config.component && (component.$slots.default = [config.component as VNode]);
  const element = component.$el as HTMLDivElement;
  Object.assign(element.style, {
    position: 'absolute',
    top: '0',
    left: '0',
  } as CSSStyleDeclaration);
  document.body.appendChild(component.$el);

  return {
    close () {
      component.$destroy();
      handleCLose();
    },
    loading (val: boolean) {
      component.$props['loading'] = val;
    },
  };
};

export default {
  install (Vue: VueConstructor) {
    Vue.prototype.$dialog = dialog;
  },
};

declare module 'vue/types/vue' {
  interface Vue {
    $dialog: typeof dialog;
  }
}
